export const responsiveCardStyles = {
  xs: {
    width: "90vw"
  },
  sm: {
    width: "375px"
  },
  md: {
    width: "475px"
  }
};

export const loginResponsiveCardStyles = {
  xs: {
    width: "90vw"
  },
  md: {
    width: "70vw"
  },
  lg: {
    width: "45vw"
  },
  xl: {
    width: "30vw"
  }
};

export const credentialCardHight = {
  xs: {
    height: "15rem"
  },
  md: {
    height: "20rem"
  }
};

export const logoWidth = {
  xs: {
    width: "80%",
    height: "80%"
  },
  sm: {
    width: "65%",
    height: "65%"
  },
  xl: {
    width: "50%",
    height: "50%"
  }
};

export const navTitleFonts = {
  xs: {
    fontSize: "1rem"
  },
  md: {
    fontSize: "1.5rem"
  }
};

export const layoutContainerPadding = {
  xs: {
    padding: "2rem"
  },
  md: {
    padding: "5rem"
  }
};

export const AUTH_STATUS = {
  LANDING: "LANDING",
  SCHOOL: "SCHOOL",
  STUDENT: "STUDENT"
} as const;

export enum APP_ROLES {
  ADMIN = "ADMIN",
  EAS = "EAS",
  SRS = "SRS",
  STUDENT = "STUDENT",
  UNENCRYPTED = "UNENCRYPTED"
}

export enum TABLE_TYPE {
  STUDENTS = "STUDENTS",
  SRS = "SRS"
}

export const SORTING_ORDER = {
  ASC: "ascend",
  DES: "descend"
};

export const SORTING_ORDER_ARRAY = [SORTING_ORDER.ASC, SORTING_ORDER.DES];

export const APP_STATUS = {
  MAINTENANCE: "maintenance",
  LIVE: "live"
} as const;

export const API_RESPONSE_STATUS = {
  OK: "ok",
  ERROR: "error",
  SUCCESS: "success"
} as const;

export const CREDENTIAL_MODAL_STATUS = {
  ADD: "ADD",
  VIEW: "VIEW",
  SELECTED: "SELECTED",
  PASSWORD: "PASSWORD",
  DELETE: "DELETE"
} as const;

export const FILE_RESTRICTION = {
  SIZE: 1024 * 1024 * 5,
  NAME_LENGTH: 50,
  TYPE: "application/pdf",
  PDF: "PDF",
  LIST_SIZE: 5
};

export const SCHOOL_RATED = {
  NOT_RATED: "Not Rated",
  PARTIAL: "Partial",
  UNSUBMITTED: "Unsubmitted",
  RATED: "Rated",
  INVALID: "Invalid"
};

export const ADM_APPLICATION_STATUS = {
  LODGED: "L"
};

export const DATE_FORMAT = {
  D_M_Y: "DD-MM-YYYY",
  HM_D_M_Y: "hh:mm DD-MM-YYYY",
  Y_M_D_HM: "YYYY-MM-DD hh:mm:ss",
  D_M_Y_HMA: "DD/MM/YYYY hh:mm a",
  D_M_Y_SLASH: "DD/MM/YYYY",
  Y_M_D: "YYYY-MM-DD"
};

export const STATE_NAME = {
  ACT: "ACT",
  NSW: "NSW",
  QLD: "QLD",
  SA: "SA",
  TAS: "TAS",
  VIC: "VIC",
  WA: "WA",
  IB: "IB"
};

export const RADIO_VALUE = {
  YES: "YES",
  NO: "NO"
};

export const RATING_LEVEL_CODE = {
  RSTL: "RSTL",
  RSTN: "RSTN",
  RSTT: "RSTT",
  RSTM: "RSTM",
  RSTC: "RSTC",
  RSTI: "RSTI",
  RSTE: "RSTE"
};

export const RATING_SCORE_CODE = {
  EXCEPTIONAL: "50",
  VERYGOOD: "40",
  GOOD: "30",
  ADEQUATE: "20",
  INADEQUATE: "10"
};

export const UTAS_RATING_SCORE_CODE = {
  P: "P",
  S: "S",
  C: "C",
  H: "H"
};

export const APPLICANT_STATUS = {
  WIP: "WIP",
  FINISH: "FINISH"
};

export const RATING_APIS = {
  YEAR11: "YEAR11",
  YEAR12: "YEAR12",
  SCORE: "SCORE",
  COMMENT: "COMMENT",
  STATUS: "STATUS",
  QUALIFICATION: "QUALIFICATION",
  TOPICS: "TOPICS"
};

export const CONTACT_FIELD = {
  SCHOOL_NAME: "schoolName",
  ROLE_ID: "roleId",
  EMAIL: "email",
  ROLES: "roles",
  TITLE: "title",
  FIRST_NAME: "firstName",
  GIVEN_NAME_1: "givenName1",
  GIVEN_NAME_2: "givenName2",
  FAMILY_NAME: "familyName",
  LAST_NAME: "lastName",
  POSITION: "position",
  ADDRESS_1: "address1",
  ADDRESS_2: "address2",
  ADDRESS_3: "address3",
  AUS_POST_CODE: "auPostCode",
  PHONE: "phone",
  MOBILE: "mobile",

  SCHOOL: "School",
  ADDRESS_4: "address4",
  STATE: "state"
};

export const PLACE_HOLDER = {
  REQUIRED: "Required",
  OPTIONAL: "Optional"
};

export const RATING_QUAL_NUM = 7;
export const SESSION_TIMEOUT_IN_SECONDS = 5400;
export const MAX_PASSWORD_CHAR = 64;

export enum WHITELABEL {
  uac = "uac",
  utas = "utas"
}

export const TABLE_FILTER = {
  ADMIN_LODGED: "appliedAdmission",
  SRS_LODGED: "srsLodged",
  SCHOOL_RATED: "schoolRated",
  FILES: "hasFiles"
};

export const FILTER_VALUE = {
  YES: "yes",
  NO: "no",
  RATED: "rated",
  UNRATED: "unrated",
  PARTIAL: "partial",
  HASFILES: "hasFiles",
  NOFILES: "noFiles"
};

export const FILTER_LABEL = {
  YES: "Yes",
  NO: "No",
  RATED: "Rated",
  UNRATED: "Unrated",
  PARTIAL: "Partially rated",
  HASFILES: "Has files",
  NOFILES: "No files"
};

export const UI_ENVIRONMENT_KEY = "_srs_ui_environment";
